<template>
    <div id="tbInfo">
        <MyTitle theTitle="申请退保信息"/>
        <div class="fd-com-scroll" v-if="isShow">
            <template v-for="(item,index) in list">
                <Slogan :theTitle="item.title"/>
                <van-cell-group>
                    <template v-if="item.type!=='sccl'">
                        <template v-for="(item1,index1) in item.dataList">
                            <van-field
                                v-model="item1.value"
                                readonly
                                :label="item1.name"
                                :class="item1.key==='other'?'fd-other':''"
                                @click="toastJointCcxx(item1.value)"
                            ></van-field>

                        </template>
                    </template>
                    <template v-else>
                        <template v-for="(item1,index1) in item.dataList">
                            <div class="fd-files-box" v-if="item1.value.length">
                                <h5>{{item1.name}}</h5>
                                <van-uploader
                                    class="uploader"
                                    multiple
                                    v-model="item1.value"
                                    :deletable="false"
                                    :max-count="0"
                                    disabled/>
                                <div class="block"></div>
                            </div>

                        </template>
                    </template>

                </van-cell-group>
            </template>

        </div>
    </div>
</template>

<script>
// 引用 —— 元素组件
import MyTitle from '../../../components/common/myTitle'
import Slogan from '../../../components/common/slogan';
import {Toast} from "vant";

// 引用 —— 前提数据
import {list3} from './dataInit'

// 引用 —— 调用接口
import {getCode,getCxtb} from "./../../../api/common";

// 引用 —— 字典转换
import {typeShjg,typeTBIsqe} from '../../../filters/index';

// 引用 —— 工具函数
import {extend} from '../../../utils/common.js';

export default {
    name: "tbInfo",
    components: {
        MyTitle,Slogan
    },
    data() {
        return {
            //前提数据
            list: extend([], list3),

            //接口获取的数据 isShow判断
            codeList_902002: [],//退保类型
            data: {},//退保信息总数据
        }
    },
    computed: {
        //是否显示
        isShow() {
            if (this.codeList_902002.length > 0 && Object.keys(this.data).length > 0) {
                this.initData();
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        toastJointCcxx(value){
            Toast(value);
        },
        //字典翻译
        translate(key,val){
            switch (key) {
                case 'nShjg':
                    return typeShjg(val);
                case 'nSfqetb':
                    return typeTBIsqe(val);
                case 'nTblx':
                    var data=this.codeList_902002.filter(item=>item.code===val)[0];
                    return data?(data.name||'--'):'--';
                default:
                    return val||'--';
            }
        },
        //初始化数据
        initData(){
            var data=this.data;
            var nShjg = String(data.nShjg);
            // nShjg='0';
            this.list[0].dataList = this.list[0].dataList.filter(item => item.power.split(',').includes(nShjg));
            data && this.list.map(item => {
                item.dataList.map(item1 => {
                    if (item.type !== 'sccl') {
                        if(item1.key!=='other'){
                            item1.value = this.translate(item1.key, data[item1.key] ? String(data[item1.key]) : '');
                        }
                        item1.type === 'date' && (item1.value = item1.value.split(' ')[0]);
                        // item1.key === 'other' && (item1.value = item1.name)&&(item1.name = '');
                    } else {
                        item1.value = [];
                        data.tbcl && data.tbcl[item1.key].map(item2 => {
                            // item1.value.push({name: item2.cClmc, wjmc: item2.cClmc, wjlj: item2.cCldz});
                            item1.value.push({cId:item2.cId,url:item2.url});
                        });
                    }
                });
            });

            console.log('--this.list',this.list);
        },
        //获取数据
        getData(){
            this.dbid = sessionStorage.getItem('dbid');
            //退保类型
            getCode({codetype: 902002}).then((res) => {
                this['codeList_902002'] = res.data;
                console.log('--codeList_902002',JSON.stringify(res));
            });

            getCxtb({dbid: this.dbid}).then((res) => {
                this.data=res.data;
            });
        }
    },
    created() {
        console.log('--tbInfo 111', window.sessionStorage.getItem("dbid"));
        this.getData();
    }
}
</script>